import { from } from "@apollo/client";
import { httpLink } from "./http-link";
import { headersLink } from "./headers-link";
import { persistedQueriesLink } from "./persisted-queries-link";
import { retryLink } from "./retry-link";
import { forceDisableAPQ } from "../utils/storage";
import { logginglink } from "./logging";
export const onegraphLink = ({ customHeaders, customLinks, endpoint, disableAPQ, }) => {
    const links = [
        headersLink(customHeaders),
        retryLink(),
        logginglink(),
        httpLink(endpoint),
    ];
    if (!disableAPQ && !forceDisableAPQ()) {
        links.unshift(persistedQueriesLink());
    }
    customLinks?.forEach((link) => links.unshift(link));
    return from(links);
};
//# sourceMappingURL=onegraph-link.js.map